import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme, type Theme } from '../hooks/useTheme';

const options: { value: Theme; icon: typeof Sun; label: string }[] = [
  { value: 'light', icon: Sun, label: 'Mode clair' },
  { value: 'dark', icon: Moon, label: 'Mode sombre' },
  { value: 'auto', icon: Monitor, label: 'Automatique' },
];

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <div
      className="flex items-center bg-warm-gray-100 dark:bg-warm-gray-800 rounded-full p-1 gap-0.5"
      role="radiogroup"
      aria-label="Thème d'affichage"
    >
      {options.map(({ value, icon: Icon, label }) => {
        const isActive = theme === value;
        return (
          <button
            key={value}
            onClick={() => setTheme(value)}
            className={`relative p-2 rounded-full transition-all duration-300 ${
              isActive
                ? 'bg-white dark:bg-warm-gray-700 shadow-sm text-aurore-dark'
                : 'text-warm-gray-500 hover:text-warm-gray-700 dark:hover:text-warm-gray-300'
            }`}
            role="radio"
            aria-checked={isActive}
            aria-label={label}
            title={label}
          >
            <Icon className="w-4 h-4" />
          </button>
        );
      })}
    </div>
  );
}
